import { render, staticRenderFns } from "./B2bAdministration.vue?vue&type=template&id=485ea759&"
import script from "./B2bAdministration.vue?vue&type=script&lang=ts&"
export * from "./B2bAdministration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports